module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Menu-857c9d73038d937b77f134a95fd4c7a0.svg";